
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/users/[userId]",
      function () {
        return require("private-next-pages/users/[userId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/users/[userId]"])
      });
    }
  